// extracted by mini-css-extract-plugin
export default {"main":"jeugd_main__8vCtr","logoJeugd":"jeugd_logoJeugd__bh1Ri"};